import React, { useState } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { FaGraduationCap } from 'react-icons/fa';
import ContactModal from '../ContactModal/ContactModal'; // Importamos el modal de contacto
import './Nav.css';

const CustomNav = () => {
  const [showContactModal, setShowContactModal] = useState(false);

  const handleShowContact = () => setShowContactModal(true);
  const handleCloseContact = () => setShowContactModal(false);

  return (
    <>
      <Navbar bg="white" expand="lg" className="custom-navbar">
        <Container className="nav-container">
          <div className="nav-left">
            <Navbar.Brand href="/" className="navbar-brand-custom">
              <FaGraduationCap className="icon" /> Ailen's English
            </Navbar.Brand>
          </div>
          <div className="nav-right">
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ml-auto nav-links">
                <Nav.Link href="/">Inicio</Nav.Link>
                <Nav.Link href="/about">Acerca de</Nav.Link>
                <Nav.Link onClick={handleShowContact} className="contact-btn">Contacto</Nav.Link>
                <Button href="/schedule" className="btn-schedule">Agenda una clase</Button>
                <Button href="/login" className="btn-login">Iniciar sesión</Button>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Container>
      </Navbar>

      {/* Modal de contacto */}
      <ContactModal show={showContactModal} handleClose={handleCloseContact} />
    </>
  );
};

export default CustomNav;
